import React, { Component } from 'react';
import { Table, Space, PageHeader } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/resetpassword';
import * as employeeActions from '../redux/actions/employee';
import {  EditOutlined } from '@ant-design/icons';

class EmployeeList extends Component {
    resetClick = (id) => {
        this.props.onOpenForm(id);
    }
    editClick = (record) => {
        this.props.onEdit({
            id: record.id,
            name: record.name,
            username: record.username,
            role: record.roles[0],
        });
    }
    render() {
        const dataSource = [];
        this.props.employees.map(
            data => {
                let item = {};
                item.key = data.id;
                item.id = data.id;
                item.name = data.name;
                item.username = data.username;
                item.roles = data.roles.map(roles => roles.name);
                item.balance=`${data.balance}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                dataSource.push(item);
            }
        );

        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                align:'center',
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                align:'center',
            },
            {
                title: 'Username',
                dataIndex: 'username',
                key: 'username',
                align:'center',
            },
            {
                title: 'Role',
                dataIndex: 'roles',
                key: 'roles',
                align:'center',
            },
            {
                title:'Balance',
                dataIndex:'balance',
                key:'balance',
                align:'right',
            },
            {
                title: 'Action',
                dataIndex: 'action',
                align:'center',
                render: (text, record) => (
                    <Space size="middle">
                        <a onClick={() => { this.editClick(record) }}><EditOutlined /> Edit</a>
                        <a style={{ color: "red" }} onClick={() => { this.resetClick(record.id) }}>ResetPassword</a>
                    </Space>
                ),
            },
        ];
        return (
            <>
                <PageHeader
                    className="site-page-header"
                    title="Users"
                />
                <Table dataSource={dataSource} columns={columns} />
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        error: state.employee.error,
        loading: state.employee.loading,
        employees: state.employee.employees
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onOpenForm: (resetId) => dispatch(actions.openResetForm(resetId)),
        onEdit: (editEmployee) => dispatch(employeeActions.openEditForm(editEmployee)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EmployeeList);